import { useCallback, useMemo } from 'react';
import Notes from 'src/components/Notes';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const InvoiceNote = () => {
  const setInvoice = useContextSelector(InvoiceContext, (value) => value.setInvoice);
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);
  const hasError = useMemo(() => !!errors.notes.length, [errors.notes.length]);

  const handleNotesChange = useCallback(
    (notes: string) => {
      setInvoice((prev) => ({ ...prev, notes }));
    },
    [setInvoice]
  );

  return (
    <PopUp
      show={hasError}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper contents={errors.notes} type="Error" />
        </div>
      }
    >
      <div className={`p-1 ${getBgColor(errors.notes)}`}>
        <Notes
          notes={invoice?.notes || ''}
          onChange={handleNotesChange}
          name={title}
          errors={errors.notes}
        />
      </div>
    </PopUp>
  );
};

export default InvoiceNote;
